import React from "react"
import PropTypes from "prop-types"
import { Field } from "redux-form/immutable"
import { Link } from "react-router-dom"

import { StyledButton } from "QuorumGrassroots/styled-components/components/StyledButton"
import { FlexRow } from "QuorumGrassroots/widgets/styled-components/styles"
import { InputField } from "app/static/frontend/forms/components/InputField"
import { StyledContrastText } from "QuorumGrassroots/styled-components/components/StyledContrastText"
import { getCustomValidator } from "QuorumGrassroots/widgets/ReusableComponents/UserInfoFormSection/customValidators"

const { FormInputType } = DjangIO.app.grassroots.types

const LoginForm = ({
    handleSubmit,
    invalid,
    loginPagePasswordLabel,
    loginPagePreText,
    loginPagePostText,
    loginPageUsernameLabel,
    ssoUrl,
    ssoLabel,
    ssoProfiles,
    submitting,
    t,
    isCampaignPage,
    campaignBackgroundColor,
    actionCenterSettings,
}) => (
    <div className="login-form">
        {loginPagePreText && (
            <StyledContrastText
                as="div"
                isCampaignPage={isCampaignPage}
                backgroundColorOverride={campaignBackgroundColor || actionCenterSettings?.background_color_override}
                className="login-form-pre-text"
                dangerouslySetInnerHTML={{ __html: loginPagePreText }}
            />
        )}
        {ssoProfiles && ssoProfiles.length > 0 ? (
            <div className="sso-profiles-container">
                {ssoProfiles.map((profile, index) => (
                    <StyledButton
                        key={`sso-profile-${index}`}
                        href={profile.url}
                        disabled={submitting}
                        isCampaignPage={isCampaignPage}
                        className="sso-profile-button"
                        style={{ marginBottom: "10px" }}
                    >
                        {profile.label || t("registration.sso.login")}
                    </StyledButton>
                ))}
            </div>
        ) : ssoUrl && !Array.isArray(window.sso_profiles) ? (
            <StyledButton href={ssoUrl} disabled={submitting} isCampaignPage={isCampaignPage}>
                {ssoLabel || t("registration.sso.login")}
            </StyledButton>
        ) : (
            <form className="login-form" onSubmit={handleSubmit}>
                <Field
                    name="username"
                    accessibilityId="username"
                    label={loginPageUsernameLabel || t("registration.username.label")}
                    dataCy="username"
                    component={InputField}
                    placeholder={loginPageUsernameLabel || t("registration.username.placeholder")}
                    displayErrorWithoutTouch={false}
                    validate={getCustomValidator(
                        FormInputType.text.value,
                        loginPageUsernameLabel || t("registration.username.label"),
                        true,
                    )}
                />
                <Field
                    name="password"
                    accessibilityId="password"
                    label={loginPagePasswordLabel || t("registration.password.label")}
                    dataCy="password"
                    component={InputField}
                    placeholder={loginPagePasswordLabel || t("registration.password.placeholder")}
                    type="password"
                    displayErrorWithoutTouch={false}
                    validate={getCustomValidator(
                        FormInputType.text.value,
                        loginPagePasswordLabel || t("registration.password.label"),
                        true,
                    )}
                />
                <StyledButton
                    onClick={handleSubmit}
                    disabled={invalid || submitting}
                    type="submit"
                    isCampaignPage={isCampaignPage}
                    activateNGGTheme
                >
                    {submitting ? t("form.submitting") : t("form.submit_form")}
                </StyledButton>
                <Link to={DjangIO.app.grassroots.types.GrassrootsFoundationalRoute.forgot_password.path}>
                    <FlexRow justifyContent="center" margin="10px 0px 0px 0px" data-cy="forgot">
                        {t("registration.password.forgot.question")}
                    </FlexRow>
                </Link>
            </form>
        )}
        {loginPagePostText && (
            <StyledContrastText
                as="div"
                isCampaignPage={isCampaignPage}
                backgroundColorOverride={campaignBackgroundColor || actionCenterSettings?.background_color_override}
                className="login-form-post-text"
                dangerouslySetInnerHTML={{ __html: loginPagePostText }}
            />
        )}
    </div>
)

LoginForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    loginPagePasswordLabel: PropTypes.string,
    loginPagePreText: PropTypes.string,
    loginPageUsernameLabel: PropTypes.string,
    ssoUrl: PropTypes.string,
    ssoLabel: PropTypes.string,
    ssoProfiles: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            label: PropTypes.string,
        }),
    ),
    submitting: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    isCampaignPage: PropTypes.bool,
}

export default LoginForm
